import React from 'react';
import { has } from 'lodash';
import { TextField } from '@material-ui/core';

import Select from 'components/ui/Select';
import { countries, provinces, states } from 'options/country.options';
import GooglePlacesAutocomplete from 'components/general/GooglePlacesAutocomplete';

const AddressFormFields = ({
  address,
  country,
  city,
  state,
  postalCode,
  errors,
  touched,
  setFieldValue,
  handleChange,
  fieldsRequired,
}) => (
  <>
    <GooglePlacesAutocomplete
      address={address}
      setFieldValue={setFieldValue}
      error={touched.address && has(errors, 'address')}
      helperText={touched.address && errors.address}
      required={fieldsRequired}
    />

    <Select
      options={countries}
      label="Country"
      variant="outlined"
      errors={errors.country}
      touched={touched.country}
      helperText={touched.country && errors.country}
      name="country"
      onChange={handleChange}
      value={country}
      required={fieldsRequired}
    />

    <Select
      options={country === 'Canada' ? provinces : states}
      label="Province/State"
      variant="outlined"
      errors={errors.state}
      touched={touched.state}
      helperText={touched.state && errors.state}
      name="state"
      onChange={handleChange}
      value={state}
      required={fieldsRequired}
    />

    <TextField
      color="primary"
      error={touched.city && has(errors, 'city')}
      helperText={touched.city && errors.city}
      label="City"
      name="city"
      onChange={handleChange}
      value={city}
      variant="outlined"
      required={fieldsRequired}
      autoComplete="chrome-off"
    />

    <TextField
      color="primary"
      error={touched.postalCode && has(errors, 'postalCode')}
      helperText={touched.postalCode && errors.postalCode}
      label="Postal/ZIP Code"
      name="postalCode"
      onChange={(e) => {
        setFieldValue('postalCode', e.target.value.toUpperCase());
      }}
      value={postalCode}
      variant="outlined"
      inputProps={{ style: { textTransform: 'uppercase' } }}
      required={fieldsRequired}
      autoComplete="chrome-off"
    />
  </>
);

export default AddressFormFields;
